import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild, AfterViewInit, AfterViewChecked, Optional } from '@angular/core';
import { first } from 'rxjs/operators';
import { AlertService } from '@app/_services';
import { OwnerStmtService } from '@app/_components/owner-stmt/owner-stmt.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CompleteLetterDialogComponent } from './complete-letter-dialog.component';
import { StatementsTaxBreakdownDialogComponent } from './statements-tax-breakdown-dialog.component';
import { PropertyService } from '@app/_components/property';
import { BlogService } from '@app/_components/blog';
import { PropertyProfileService } from '@app/_components/property-profile/property-profile.service';
import { ReservationService } from '@app/_components/reservation';
import { ExpenseService } from '@app/_components/expense';
import { ExpenseComponent } from '@app/_components/expense/expense/expense.component';
import { MessageService } from 'primeng/api';
import { OwnerStatementMailService } from '@app/_components/owner-statements/owner-statement-mail.service';
import { ReservationLedgerListComponent } from '@app/_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';



@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class StatementsComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('closeButton') closeButton!: ElementRef;
  @ViewChild('contentContainer') contentContainer!: ElementRef;
  ownerStmtOjb: any;
  ownerStmt: any;
  ownerStmtId: any;
  isDialogMode: boolean = false;
  ownerRezList: any = [];
  ownerExpList: any = [];
  totalAmount: any;

  statementDate = new Date();
  serviceDate = new Date();
  checkInDate = new Date();
  checkOutDate = new Date();
  expenseCategories: any[] = [];
  formLoading = false;
  
  propertyProfile: any;

  // Content template properties
  fullContent: string = '';
  displayContent: string = ''; // Content to display in card (full HTML)
  safeDisplayContent: SafeHtml = ''; // Safe HTML content for display
  safeFullContent: SafeHtml = ''; // Full content for PDF (no truncation)
  showViewCompleteLink: boolean = false;
  private overflowCheckScheduled: boolean = false;
  
  // PDF mode flag (kept for template compatibility, but always false since we use backend PDF generation)
  isPdfMode: boolean = false;


  // Summary calculation properties
  summaryStartingBalance: number = 0;
  summaryRents: number = 0;
  summaryPaidNights: number = 0;
  summaryGuestNights: number = 0;
  summaryOwnerNights: number = 0;
  summaryOwnerGuestNights: number = 0;
  summaryMaintenanceNights: number = 0;
  summaryOccupancyRate: number = 0;
  summaryTaxRevenue: number = 0;
  summaryMaintenanceCredit: number = 0;
  summaryHousekeepingCredit: number = 0;
  summarySubtotalCredits: number = 0;
  summaryMaintenanceDebit: number = 0;
  summaryHousekeepingDebit: number = 0;
  summaryManagementDebit: number = 0;
  summaryTaxPaidDebit: number = 0;
  summarySubtotalDebits: number = 0;
  summaryNetProceeds: number = 0;
  ownerStmtOjbData: any;
  developmentId: any;
  properties: any[] = [];
  statements: any[] = [];
  openingReservation: any = {};
  isEnableEdit: boolean = true;
  expenseLoading: boolean = false;
  summaryPaymentToOwner: number = 0;
  summaryEndingBalance: number = 0;
  isDownloading: boolean = false;
  isPrinting: boolean = false;
  isSendingEmail: boolean = false;
  showTaxBreakdownDialog = false;
  taxBreakdownType: 'revenue' | 'expense' = 'revenue';
  taxBreakdownData: any[] = [];
  taxBreakdownTitle: string = '';
  reservationStatuses: any;
  constructor(
    private ownerStmtService: OwnerStmtService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private ownerStatementMailService: OwnerStatementMailService,
    private sanitizer: DomSanitizer,
    private reservationService: ReservationService,
    private expenseService: ExpenseService,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    @Optional() @Inject(MAT_DIALOG_DATA) data: any) {
    this.expenseCategories = expenseService.expenseCategories;
    this.isDialogMode = data?.isDialogMode ?? false;
    if (data?.ownerStmt) {
      this.ownerStmt = data.ownerStmt;
      this.ownerStmtId = data.ownerStmt.ownerStmtId;
    } else {
      const idParam = this.activatedRoute.snapshot.paramMap.get('ownerStmtId');
      if (idParam) {
        const id = Number(idParam);
        if (!isNaN(id)) {
          this.ownerStmtId = id;
          this.ownerStmt = { ownerStmtId: id };
        }
      }
    }

    this.reservationStatuses = this.reservationService.reservationStatuses;
  }

  urlEndpoint = 'owner-stmts';


  // @Input() ownerStmt: OwnerStmt;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  months = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER", "YTD"
  ];

  tableRows = [
    { label: "Starting Balance", field: "startingBalance" },
    { label: "Rents", field: "rentalRevenue" },
    // { label: "Paid Nights", field: "paidNights" },
    // { label: "Guest Nights", field: "guestNight" },
    // { label: "Owner Nights", field: "ownerNights" },
    // { label: "Owner Guest Nights", field: "ownerGuestNights" },
    // { label: "Maintenance Nights", field: "maintenanceNights" },
    // { label: "Occupancy Rate", field: "occupancyRate" },
    { label: "Tax", field: "taxRevenue" },
    { label: "Hskp Credit", field: "housekeepingCreditTotal" },
    { label: "Maint Credit", field: "maintenanceCreditTotal" },
    { label: "Total Revenue", field: "totalRevenueWithExpenseCredit" },
    { label: "", field: "empty" },
    { label: "Housekeeping", field: "housekeepingPaidByOwnerTotalWithExpenseCredit" },
    { label: "Maintenance", field: "maintenancePaidByOwnerTotalWithExpenseCredit" },
    { label: "Management", field: "mgntExpense" },
    { label: "Tax Paid", field: "taxExpense" },
    { label: "Total Expenses", field: "totalExpenseWithExpenseCredit" },
    { label: "", field: "empty" },
    { label: "Net Proceeds", field: "totalNetProceed" },
    { label: "", field: "empty" },
    { label: "Payment To Owner", field: "paymentToOwner" },
    { label: "Ending Balance", field: "endingBalance" }
  ];


  ngOnInit(): void {
    this.ownerRezList = this.ownerStmt?.ownerStmtRezs;
    this.ownerExpList = this.ownerStmt?.ownerStmtExps;
    // Initialize safe display content
    this.safeDisplayContent = this.getSafeHtml('Loading...');
    this.fetchOwnerStmt();
  }

  ngAfterViewInit(): void {
    // Check overflow after view is initialized
    setTimeout(() => {
      this.checkContentOverflow();
    }, 200);
  }

  ngAfterViewChecked(): void {
    // Check overflow when content changes (throttled to avoid performance issues)
    if (this.displayContent && this.contentContainer && !this.overflowCheckScheduled) {
      this.overflowCheckScheduled = true;
      setTimeout(() => {
        this.checkContentOverflow();
        this.overflowCheckScheduled = false;
      }, 100);
    }
  }

  viewReservationLedger(reservationId: any) {

		const dialogConfig = new MatDialogConfig();

		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "100vw";
		dialogConfig.maxHeight = "100vh";
		dialogConfig.height = "100vh";

		dialogConfig.data = {
			title: 'Reservation Ledgers',
			showFilter: true,
			showPagination: false,
			displayClose: false,
			isPopup: true,
			reservationId: reservationId

		};
		const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);

	}

  loadContentTemplate(content: string): void {
    this.fullContent = content;
    // Display full HTML content (not truncated) - show everything until card end
    this.displayContent = content || '';
    // Update safe HTML content
    this.safeDisplayContent = this.getSafeHtml(this.displayContent || 'Loading...');
    // Also set full content for PDF mode (no truncation)
    this.safeFullContent = this.getSafeHtml(this.fullContent || '');

    // Check for overflow after content is loaded
    setTimeout(() => {
      this.checkContentOverflow();
    }, 100);
  }

  checkContentOverflow(): void {
    if (this.contentContainer && this.contentContainer.nativeElement) {
      const element = this.contentContainer.nativeElement;
      // Check if content height exceeds container height (with some margin)
      const hasOverflow = element.scrollHeight > element.clientHeight + 10;
      this.showViewCompleteLink = hasOverflow;

      // Add/remove class for fade effect
      if (hasOverflow) {
        element.classList.add('has-overflow');
      } else {
        element.classList.remove('has-overflow');
      }
    } else {
      // Fallback: if content is very long, show the link (threshold aligned with larger container)
      const textLength = this.fullContent.replace(/<[^>]*>/g, '').trim().length;
      this.showViewCompleteLink = textLength > 1600;
    }
  }

  openCompleteLetterDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.height = '80vh';

    dialogConfig.data = {
      title: '',
      ownerNotes: this.ownerStmtOjb?.ownerNotes,
      content: this.fullContent
    };

    this.dialog.open(CompleteLetterDialogComponent, dialogConfig);
  }

  getSafeHtml(html: string): SafeHtml {
    if (!html) return '';
    // Use bypassSecurityTrustHtml to preserve HTML formatting
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }


  getReservationStatus(reservationStatus: any) {
    if (reservationStatus) {
      const status = this.reservationStatuses.find((e: any) => e.value == reservationStatus);
      return status.name;
    }
    else {
      return '-';
    }
  }


  fetchOwnerStmt() {
    const id = this.ownerStmtId ?? this.ownerStmt?.ownerStmtId;
    if (id == null || id === undefined) {
      return;
    }
    try {
      this.formLoading = true;
      this.ownerStmtService.findStmtById(id)
        .subscribe(
          res => {
            console.log('findAllOwnerStmt Data: ' + JSON.stringify(res));
            this.ownerStmtOjb = res.data.ownerStmt;
            this.loadContentTemplate(this.ownerStmtOjb?.stmtContent?.bodyHtml || 'Statement letter not found');
            this.formLoading = false;
            this.calculateSummary();
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.formLoading = false;
          },
          () => {
          });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.formLoading = false;
      this.alertService.error(error);
    }
  }

  calculateTotal(amount: any, i: any) {
    if (i === 0) {
      this.totalAmount = 0;
      this.totalAmount = amount;
    } else {
      this.totalAmount = this.totalAmount + amount;
    }
  }

  getExpenseTypeName(ownerExp: any) {
    if (ownerExp?.expenseCategory) {
      const status = this.expenseCategories.find((e: any) => e.value == ownerExp.expenseCategory);
      return status?.name || '';
    }
    else {
      return '';
    }
  }

  getResSummStmtNights() {
    let totalNights = 0;
    this.ownerStmtOjb?.reservationsSummaries.forEach(reservationsSummary => {
      totalNights = totalNights + reservationsSummary?.stmtNights;
    });
    return totalNights;
  }



  getValueByMonth(month: string, field: string): number {
    const data = this.ownerStmtOjb?.yearlySummary.stmtSummeryAPIs.find(
      (stmt) => stmt.month.toUpperCase() === month
    );
    return data ? data[field] || 0 : 0;
  }

  openReservation(reservation: any, event: any) {
    let reservationId = reservation?.reservationId;
    event.stopPropagation();
    this.openingReservation[reservationId] = true;
    this.reservationService.getOrderIdByReservationId(reservationId).pipe(first()).subscribe(
      (res: any) => {
        console.log('Order ID: ' + JSON.stringify(res));
        window.open(`https://admin.kbmhawaii.com/order/${res.data.orderId}`, '_blank');
        this.openingReservation[reservationId] = false;
      },
      (err: any) => {
        console.log('Error fetching order ID: ' + JSON.stringify(err));
        this.openingReservation[reservationId] = false;
      }
    );
  }

  // getYearToDateTotal(field: string): number {
  //   return this.ownerStmtOjb.yearlySummary.stmtSummeryAPIs.reduce(
  //     (sum, stmt) => sum + (stmt[field] || 0), 
  //     0
  //   );
  // }

  isBoldRow(field: string): boolean {
    const boldFields = ["totalRevenue", "totalExpense", "paymentToOwner"];
    return boldFields.includes(field);
  }

  calculateSummary(): void {
    this.summaryStartingBalance = this.ownerStmtOjb?.stmtSummery?.startingBalance || 0;
    this.summaryRents = this.ownerStmtOjb?.stmtSummery?.rentalRevenue || 0;
    this.summaryPaidNights = this.ownerStmtOjb?.stmtSummery?.paidNights || 0;
    this.summaryGuestNights = this.ownerStmtOjb?.stmtSummery?.guestNight || 0;
    this.summaryOwnerNights = this.ownerStmtOjb?.stmtSummery?.ownerNights || 0;
    this.summaryOwnerGuestNights = this.ownerStmtOjb?.stmtSummery?.ownerGuestNights || 0;
    this.summaryMaintenanceNights = this.ownerStmtOjb?.stmtSummery?.maintenanceNights || 0;
    this.summaryOccupancyRate = this.ownerStmtOjb?.stmtSummery?.occupancyRate || 0;
    this.summaryTaxRevenue = this.ownerStmtOjb?.stmtSummery?.taxRevenue || 0;
    this.summaryMaintenanceCredit = this.ownerStmtOjb?.stmtSummery?.maintenanceCreditTotal || 0;
    this.summaryHousekeepingCredit = this.ownerStmtOjb?.stmtSummery?.housekeepingCreditTotal || 0;
    this.summarySubtotalCredits = this.ownerStmtOjb?.stmtSummery?.totalRevenueWithExpenseCredit || 0;
    this.summaryMaintenanceDebit = this.ownerStmtOjb?.stmtSummery?.maintenancePaidByOwnerTotalWithExpenseCredit || 0;
    this.summaryHousekeepingDebit = this.ownerStmtOjb?.stmtSummery?.housekeepingPaidByOwnerTotalWithExpenseCredit || 0;
    this.summaryManagementDebit = this.ownerStmtOjb?.stmtSummery?.mgntExpense || 0;
    this.summaryTaxPaidDebit = this.ownerStmtOjb?.stmtSummery?.taxExpense || 0;
    this.summarySubtotalDebits = this.ownerStmtOjb?.stmtSummery?.totalExpenseWithExpenseCredit || 0;
    this.summaryNetProceeds = this.ownerStmtOjb?.stmtSummery?.totalNetProceed || 0;
    this.summaryPaymentToOwner = this.ownerStmtOjb?.stmtSummery?.paymentToOwner || 0;
    this.summaryEndingBalance = this.ownerStmtOjb?.stmtSummery?.endingBalance || 0;

  }

  // ============================================
  // PDF Generation - Helper Methods
  // ============================================

  /**
   * Download PDF from blob
   */
  private downloadPdf(blob: Blob, filename: string = 'owner_statement.pdf'): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  /**
   * Print PDF from blob
   */
  private printPdf(blob: Blob): void {
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, '_blank');
    
    
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      };
    }
    else {
      this.messageService.add({ severity: 'warn', summary: 'Pop-up Blocked', detail: 'Popups may be blocked. Please allow popups to print the PDF.', life: 3000 });
      this.isPrinting = false;
      this.isEnableEdit = true;
    }
  }

  // ============================================
  // PDF Generation - Public Methods
  // ============================================

  async downloadAsPdf(event: Event): Promise<void> {
    event.preventDefault();
    this.isEnableEdit = false;
    this.isDownloading = true;

    try {
      this.ownerStmtService.getPdfAsBlob(this.ownerStmtId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            const blob = response.body as Blob;
            if (!blob || blob.size === 0) {
              throw new Error('No PDF data received from server');
            }

            // Extract filename from header
            const contentDisposition = response.headers.get('content-disposition');
            let filename = 'owner_statement.pdf';
            if (contentDisposition) {
              const match = contentDisposition.match(/filename="?([^"]+)"?/);
              if (match && match[1]) {
                filename = match[1];
              }
            }
            
            this.downloadPdf(blob, filename);
            this.isDownloading = false;
            this.isEnableEdit = true;
          },
          error: (error: any) => {
            console.error('Error fetching PDF:', error);
            this.alertService?.error('Failed to generate PDF. Please try again.');
            this.isDownloading = false;
            this.isEnableEdit = true;
          }
        });
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.alertService?.error('Failed to generate PDF. Please try again.');
      this.isDownloading = false;
      this.isEnableEdit = true;
    }
  }

  async printAsPdf(event: Event): Promise<void> {
    event.preventDefault();
    this.isEnableEdit = false;
    this.isPrinting = true;

    try {
      this.ownerStmtService.getPdfAsBlob(this.ownerStmtId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            const blob = response.body as Blob;
            if (!blob || blob.size === 0) {
              throw new Error('No PDF data received from server');
            }
            
            this.printPdf(blob);
            this.isPrinting = false;
            this.isEnableEdit = true;
          },
          error: (error: any) => {
            console.error('Error fetching PDF for print:', error);
            this.alertService?.error('Failed to generate PDF for printing. Please try again.');
            this.isPrinting = false;
            this.isEnableEdit = true;
          }
        });
    } catch (error) {
      console.error('Error generating PDF for print:', error);
      this.alertService?.error('Failed to generate PDF for printing. Please try again.');
      this.isPrinting = false;
      this.isEnableEdit = true;
    }
  }

  /**
   * Send statement via email (PDF + owner emails via shared service).
   */
  sendStatementEmail(event: Event): void {
    event.preventDefault();
    this.isEnableEdit = false;
    this.isSendingEmail = true;
    const statement = {
      ownerStmtId: this.ownerStmtId,
      propertyCode: this.ownerStmtOjb?.property,
      startDate: this.ownerStmtOjb?.startDate
    };
    try {
      this.ownerStatementMailService.openStatementMailCompose(statement, {
        onLoading: (v) => {
          this.isSendingEmail = v;
          this.isEnableEdit = !v;
        },
        onPublishRequired: (summary, detail) => this.messageService.add({ severity: 'error', summary, detail, life: 5000 })
      });
    } catch (error) {
      console.error('Error preparing statement for email:', error);
      this.alertService?.error('Failed to prepare statement for email. Please try again.');
      this.isSendingEmail = false;
      this.isEnableEdit = true;
    }
  }

  openExpenseEdit(expense: any) {
    try {
      this.expenseLoading = true;
      this.expenseService.findById(expense?.expenseId)
        .subscribe(
          (res: any) => {
            console.log('expense-findById SUCCESS: ' + JSON.stringify(res));
            this.expenseLoading = false;
            this.onOpenExpenseFormEdit(res.data.expense);
          },
          (err: any) => {
            console.log('expense-findById FAIL: ' + JSON.stringify(err));
            this.expenseLoading = false;
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.expenseLoading = false;
      this.alertService.error(error);
    }
  }

  onOpenExpenseFormEdit(expense: any) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '60vw';
    dialogConfig.width = '40vw';

    // pass data
    dialogConfig.data = {
      expense: expense,
      isDialogMode: true,
      title: 'Edit Expense'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ExpenseComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        // refresh the order to show updated expense
        this.fetchOwnerStmt();
        // close the dialogBox
        dialogRef.close();
      });

    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);
        // refresh the order to show updated expense
        this.fetchOwnerStmt();
        // close the dialogBox
        dialogRef.close();
      });
  }

  openTaxBreakdownDialog(type: 'revenue' | 'expense'): void {
    this.taxBreakdownType = type;
    if (type === 'revenue') {
      this.taxBreakdownData = this.ownerStmtOjb?.stmtSummery?.taxRevenueList || [];
      this.taxBreakdownTitle = 'Tax Breakdown';
    } else {
      this.taxBreakdownData = this.ownerStmtOjb?.stmtSummery?.taxRevenuePaidOnYourBehalfList || [];
      this.taxBreakdownTitle = 'Tax Breakdown';
    }
    if (this.isDialogMode) {
      this.dialog.open(StatementsTaxBreakdownDialogComponent, {
        width: '600px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        panelClass: 'owner-stmt-tax-breakdown-mat-dialog',
        data: {
          title: this.taxBreakdownTitle,
          rows: this.taxBreakdownData,
        },
      });
      return;
    }
    this.showTaxBreakdownDialog = true;
  }

  openReservationTaxBreakdown(ownerRez: any, event?: Event): void {
    if(!ownerRez?.taxes?.length) {
      return;
    }
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const rawTaxes = ownerRez?.taxes || [];
    const taxes = rawTaxes.map((t: any) => ({
      name: t?.taxShortName || t?.taxName || '-',
      amount: t?.taxAmount ?? 0,
      rate: t?.taxRate
    }));
    const title = ownerRez?.reservationId
      ? `Tax Breakdown - Res #${ownerRez.reservationId}`
      : 'Tax Breakdown';
    if (this.isDialogMode) {
      this.dialog.open(StatementsTaxBreakdownDialogComponent, {
        width: '600px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        panelClass: 'owner-stmt-tax-breakdown-mat-dialog',
        data: {
          title,
          rows: taxes,
        },
      });
      return;
    }
    this.taxBreakdownType = 'revenue';
    this.taxBreakdownData = taxes;
    this.taxBreakdownTitle = title;
    this.showTaxBreakdownDialog = true;
  }

  getTotalTaxAmount(): number {
    return this.taxBreakdownData.reduce((total, tax) => total + (tax.amount || 0), 0);
  }

  
}
